/*
 * Two logical columns bind the same row field `value` (editable vs view). AG Grid requires unique column ids.
 */
export const QUOTE_TOP_GRID_COL_VALUE_EDITABLE = 'quoteTopValueEditable';
export const QUOTE_TOP_GRID_COL_VALUE_READONLY = 'quoteTopValueReadOnly';
